import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ShippingDetailsAddress } from './ShippingDetailsAddress/ShippingDetailsAddress';
import { ShippingDetailsDisclaimer } from './ShippingDetailsText/ShippingDetailsDisclaimer';
import { ShippingDetailsQuotesTable } from './ShippingDetailsQuotes/ShippingDetailsQuotesTable';
import { ShippingDetailsRequestQuote } from './ShippingDetailsText/ShippingDetailsRequestQuote';
import { ShippingDetailsServicesTable } from './ShippingDetailsServices/ShippingDetailsServicesTable';
import { shippingModal } from './shippingMessages';

export function ShippingDetailsContainerComponent(props) {
    const {
        currency,
        viewer,
        openQuoteRequestModal,
        hasQuote,
        showRequestCta,
        quoteRequestStatus,
        blockRequest,
    } = props;
    const { item, shipmentQuotes, user } = viewer || {};
    const relevantShippingInfo = get(viewer, 'relevantShippingInfo');

    if (!viewer) {
        return null;
    }

    return (
        <div>
            <BarHeader title={shippingModal.modalTitle} />
            <ModalBody>
                {hasQuote && <ShippingDetailsAddress item={item} />}
                <div>
                    {hasQuote && (
                        <ShippingDetailsQuotesTable
                            currency={currency}
                            shipmentQuotes={shipmentQuotes}
                            relevantShippingInfo={relevantShippingInfo}
                        />
                    )}
                    {/* request quote text */}
                    <ShippingDetailsRequestQuote
                        quoteRequestStatus={quoteRequestStatus}
                        openQuoteRequestModal={openQuoteRequestModal}
                        blockRequest={blockRequest}
                    />
                    {/* services table */}
                    <ShippingDetailsServicesTable />
                    <ShippingDetailsDisclaimer
                        viewer={viewer}
                        item={item}
                        user={user}
                        shipmentQuotes={shipmentQuotes}
                        openQuoteRequestModal={openQuoteRequestModal}
                        showRequestCta={showRequestCta}
                    />
                </div>
            </ModalBody>
        </div>
    );
}

ShippingDetailsContainerComponent.propTypes = {
    hasQuote: PropTypes.bool,
    viewer: PropTypes.object,
    user: PropTypes.object,
    currency: PropTypes.string,
    openQuoteRequestModal: PropTypes.func,
    showRequestCta: PropTypes.bool,
    quoteRequestStatus: PropTypes.string.isRequired,
    blockRequest: PropTypes.bool,
};

export const ShippingDetailsContainer = createFragmentContainer(ShippingDetailsContainerComponent, {
    viewer: graphql`
        fragment ShippingDetailsContainer_viewer on Viewer {
            item(itemId: $itemId, pageType: SHIPPING_MODAL) @include(if: $shouldFetchItem) {
                ...ShippingDetailsAddress_item
            }
            relevantShippingInfo(buyerId: $userId, itemId: $itemId) @include(if: $shouldFetchItem) {
                ...ShippingDetailsQuotesTable_relevantShippingInfo
            }
            shipmentQuotes(itemId: $itemId, searchView: IGNORE_LOCAL_PICKUP, first: 10)
                @include(if: $shouldFetchItem) {
                ...ShippingDetailsQuotesTable_shipmentQuotes
            }
        }
    `,
});
